export interface StepText {
  title: string;
  desc?: string;
}

export enum ELIMINATIONS_CHOICES {
  YES = 'yes',
  NO = 'no'
}
